'use client'

import { usePathname } from 'next/navigation';
import { localizedHref } from '@/lib/locale';
import { Button } from '@/components/ui/Button';

const t = {
  en: {
    label: '404 — Page not found',
    heading: "Oops, this page doesn't exist",
    body: "The page you're looking for may have been moved or no longer exists. Let's get you back on track.",
    home: 'Back to Home',
    contact: 'Contact Us',
  },
  es: {
    label: '404 — Página no encontrada',
    heading: 'Vaya, esta página no existe',
    body: 'La página que buscas puede haber sido movida o ya no existe. Volvamos a la página principal.',
    home: 'Volver al inicio',
    contact: 'Contáctanos',
  },
} as const;

export default function NotFound() {
  const pathname = usePathname();
  const lang = pathname?.startsWith('/es') ? 'es' : 'en';
  const i18n = t[lang];

  return (
    <section className="section-container flex flex-col items-center justify-center text-center py-24 lg:py-40 min-h-[60vh]">
      <p className="text-brand-primary font-semibold text-sm uppercase tracking-widest mb-4">
        {i18n.label}
      </p>
      <h1 className="mb-6">
        {i18n.heading}
      </h1>
      <p className="max-w-md mb-10 text-slate-600">
        {i18n.body}
      </p>
      <div className="flex gap-4 flex-wrap justify-center">
        <Button
          label={i18n.home}
          href={localizedHref(lang)}
          iconLeft="ArrowLeft"
          variant="primary"
        />
        <Button
          label={i18n.contact}
          href={localizedHref(lang, '#contact')}
          variant="ghost"
        />
      </div>
    </section>
  );
}
